import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaymentDateFilterType } from '../types';

interface DashboardState {
  branchCurrentPaymentBasedOnFilter: PaymentDateFilterType;
}

const initialState: DashboardState = {
  branchCurrentPaymentBasedOnFilter: 'due_at'
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateBranchCurrentPaymentBasedOnFilter: (
      state,
      action: PayloadAction<PaymentDateFilterType>
    ) => {
      state.branchCurrentPaymentBasedOnFilter = action.payload;
    },
    resetDashboardState: () => initialState
  }
});

export const { updateBranchCurrentPaymentBasedOnFilter, resetDashboardState } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
